import React from 'react';
import { Progress as AntdProgress, ProgressProps as AntdProgressProps } from 'antd';
import {
	WarnWhenReachAntdVersionMetadata,
	warnWhenReachedAntdVersion
} from '../../helper/warn-when-reached-antd-version';
import classnames from 'classnames';
import type { DistributiveOmit } from '@bringg/types';

import s from './progress.module.scss';

const warningObj: WarnWhenReachAntdVersionMetadata = {
	componentName: 'Progress',
	minAntdVersion: '5.3.0',
	message:
		'you can remove the custom support for custom `size` property as it supported by default in antd in this version',
	urlReference: 'https://ant.design/components/progress#progress-demo-size'
};

type ProgressProps = DistributiveOmit<AntdProgressProps, 'type' | 'size'> &
	(
		| {
				type?: Exclude<AntdProgressProps['type'], 'circle'>;
				size?: AntdProgressProps['size'];
		  }
		| {
				type: 'circle';
				size?: AntdProgressProps['size'] | number;
		  }
	);

const Progress = ({ size, className, style, ...props }: ProgressProps) => {
	warnWhenReachedAntdVersion(warningObj);

	const useNumericSize = typeof size === 'number';
	const wrappedStyle = style || useNumericSize ? { ...style, '--progress-size': size + 'px' } : style;
	return (
		<AntdProgress
			className={classnames(className, {
				[s.numericSize]: useNumericSize
			})}
			style={wrappedStyle}
			size={useNumericSize ? 'default' : size}
			{...props}
		/>
	);
};

export default Progress;
